<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/requisicaoServico', query: $route.query }">
        Compras/Requisição Serviço</router-link
      >
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Visualizar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="localSelected"
              :items="filteredLocal"
              label="Local de Entrega *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Local de entrega é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-subheader><strong>Prioridade</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="tipo" :readonly="readOnly" row>
                <v-radio label="Normal" value="Normal"></v-radio>
                <v-radio label="Emergencial" value="Emergencial"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8">
            <v-textarea
              :clearable="!validaObservacao"
              auto-grow
              clear-icon="mdi-close-circle"
              label="Observação"
              v-model="observacao" v-uppercase
              maxlength="200"
              counter
              rows="1"
              :readonly="validaObservacao"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="N° Requisição"
              v-model="requisicaoServico.nome"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="3000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addProduto()"
                :disabled="readOnly"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar serviço</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-form ref="formProd" v-model="valid" lazy-validation>
        <v-card>
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items="produtosL"
            item-key="index"
            :items-per-page="-1"
          >
            <template v-slot:item.codigo="{ item }">
              {{
                item.codigo === null || item.codigo == "" ? "NA" : item.codigo
              }}
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                v-model="item.quantidade"
                hide-details
                dense
                type="number"
                :rules="[validarQuantidadeItem]"
                v-mask="['#####']"
              />
            </template>
            <template v-slot:item.centroCusto="{ item }">
              <div v-if="!item.editingCentroCusto">
                <div
                  @click="item.editingCentroCusto = true"
                  style="cursor: pointer"
                >
                  {{
                    (item.centroCustoSelected &&
                      item.centroCustoSelected.descricao) ||
                    "Selecionar..."
                  }}
                </div>

                <div
                  v-if="item.centroCustoErro"
                  style="color: #b00020; font-size: 12px"
                >
                  O Centro de Custo é obrigatório
                </div>
              </div>

              <v-autocomplete
                v-else
                v-model="item.centroCustoSelected"
                :items="centrosCusto"
                item-text="descricao"
                item-value="id"
                return-object
                :readonly="isAllowed"
                autofocus
                @blur="
                  () => {
                    item.editingCentroCusto = false;
                    item.centroCustoErro = !(
                      item.centroCustoSelected && item.centroCustoSelected.id
                    );
                  }
                "
                @change="
                  (val) => {
                    changeProduto(item, val);
                    item.centroCustoErro = !(val && val.id);
                    item.editingCentroCusto = false;
                  }
                "
                :rules="[
                  (v) => !!(v && v.id) || 'O Centro de Custo é obrigatório',
                ]"
                required
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="info"
                    @click="editaProduto(item.index)"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="readOnly"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeProduto(item.index)"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="readOnly"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
            <template v-slot:item.index="{ item }">
              {{ item.index + 1 }}
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ produtosL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn
              @click="enviar"
              color="success"
              class="mr-4"
              v-if="!readOnly"
            >
              Salvar
            </v-btn>
            <v-btn
              :to="{ path: '/requisicaoServico', query: $route.query }"
              color="error"
              class="mr-4"
              v-if="!readOnly"
            >
              Voltar
            </v-btn>
            <v-btn
              :to="{ path: '/requisicaoServico', query: $route.query }"
              color="success"
              class="mr-4"
              v-else
            >
              Voltar
            </v-btn>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="900px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Serviço</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <servico
                ref="prdAdd"
                :produtosL="produtosL"
                :showModal="showModal"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Modal
      v-model="showModalProduto"
      modalStyle="max-width: 1000px"
      title="Editar produto"
      @after-open="updateProduto()"
    >
      <edita-produto ref="editprd"></edita-produto>
      <v-row>
        <v-col align="right">
          <v-btn
            @click="showModalProduto = false"
            depressed
            color="primary"
            :style="{
              backgroundColor: '#ff5252 !important',
              color: 'white !important',
              margin: '0px 10px 0px 0px',
            }"
            text
          >
            Voltar
          </v-btn>
          <v-btn
            @click="atualizar"
            color="primary"
            :style="{
              backgroundColor: '#4caf50 !important',
              color: 'white !important',
            }"
            text
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </Modal>
  </div>
</template>

<script>
import { editarRequisicaoAsync, obterRequisicaoPorIdAsync } from "../../../services/requisicaoServicoService";
import { mapState, mapActions } from "vuex";
import Servico from "../Servico";
import EditaProduto from "../EditaProduto";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarRequisicao",
  data: () => ({
    tipo: "1",
    overlay: false,
    valid: true,
    descricao: null,
    observacao: null,
    localSelected: null,
    unidadeAdmSelected: null,
    produtosL: [],
    indexEdit: null,
    showModal: false,
    showModalProduto: false,
    errorMessage: false,
    errorMessageValue: null,
    readOnly: false,
    headers: [
      { text: "Item", value: "index", sortable: false },
      { text: "Produto", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("requisicaoServico", ["requisicaoServico"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    filteredLocal() {
      return this.locais.filter((lc) => {
        return lc.idTipoLocais === 1 || lc.idTipoLocais === 3;
      });
    },
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return lc.idTipoLocais === 2 || lc.idTipoLocais === 3;
      });
    },
    validaObservacao() {
      return this.readOnly;
    },
  },
  methods: {
    ...mapActions("produto", ["atualizarServicos"]),
    ...mapActions("requisicaoServico", [
      "atualizarRequisicaoServico",
      "updateRequisicaoServico",
    ]),
    async enviar() {
      const quantidadesOk = this.validarQuantidadeItens();

      if (!quantidadesOk) {
        this.errorMessageValue =
          "Informe uma quantidade maior que zero em todos os itens.";
        this.errorMessage = true;
        if (this.$store) {
          this.$store.dispatch("ui/showSnackbar", {
            text: "Informe uma quantidade maior que zero em todos os itens.",
            color: "error",
            timeout: 3000,
          });
        }
        return;
      }

      const centrosOk = this.validarCentroCustoItens();
      if (!centrosOk) {
        this.errorMessageValue =
          "Preencha o Centro de Custo em todos os itens.";
        this.errorMessage = true;
        return;
      }
      if (this.produtosL == null || this.produtosL.length <= 0) {
        this.errorMessageValue = "Adicione os produtos à requisição!";
        this.errorMessage = true;
      } else if (this.$refs.form.validate() && this.$refs.formProd.validate()) {
        this.overlay = true;
        try {
          const resposta = await editarRequisicaoAsync(
            this.requisicaoServico.id,
            this.unidadeAdmSelected.id,
            this.localSelected.id,
            this.observacao,
            this.tipo == "Normal" ? "N" : "E",
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicaoServico(
              this.mountObjRequisicao(resposta.data)
            );
            this.$store.dispatch("ui/showSnackbar", {
              text: "Atualizado com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicaoServico",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } else {
        this.errorMessageValue = "Preencha os locais!";
        this.errorMessage = true;
        return;
      }
    },

    addProduto: function () {
      this.showModal = true;
    },
    disable(value) {
      return (
        Object.prototype.toString.call(value) === "[object Array]" &&
        !(JSON.stringify(value) === "[]")
      );
    },
    removeProduto(index) {
      this.produtosL = this.produtosL.filter((p) => p.index != index);
    },
    editaProduto(index) {
      this.indexEdit = index;
      this.showModalProduto = true;
    },
    changeProduto(item, centroCusto) {
      item.idCentroCusto = centroCusto.id;
      item.centroCusto = centroCusto.descricao;
    },
    updateProduto() {
      var produto = this.produtosL.filter((p) => p.index === this.indexEdit);
      this.$refs.editprd.updateObject2(produto[0]);
    },
    atualizar: function (e) {
      var produtoValido = this.$refs.editprd.updateObjectEstate();
      if (!produtoValido) {
        e.preventDefault();
        this.errorMessageValue = "Informe a quantidade!";
        this.errorMessage = true;
        return;
      }
      const produto = this.produtosL.find((p) => p.index === this.indexEdit);
      if (produto) {
        produto.quantidade = this.$refs.editprd.quantidade;
        produto.observacao = this.$refs.editprd.observacao;
      }
      this.showModalProduto = false;
    },
    async carregarTela() {
      this.overlay = true;
      try {
        await this.obterListas();

        const idRota = Number(this.$route.query.id);
        if (idRota > 0) {
          const resposta = await obterRequisicaoPorIdAsync(idRota);
          if (!resposta || resposta.status !== 200) {
            this.$router.push("/requisicaoServico");
            return;
          }
          this.atualizarRequisicaoServico(resposta.data);
        }

        if (!this.requisicaoServico?.id) {
          this.$router.push("/requisicaoServico");
          return;
        }

        this.inicializarCampos();
      } finally {
        this.overlay = false;
      }
    },
    inicializarCampos() {
      var index = 0;
      this.readOnly =
        !getUserPermission(8) || this.requisicaoServico.status != "AA";
      this.tipo = this.requisicaoServico.prioridade.toString();
      this.produtosL = JSON.parse(
        JSON.stringify(this.requisicaoServico.produtos || [])
      );
      this.unidadeAdmSelected = this.findLocal(
        this.requisicaoServico.idUnidadeAdm
      );
      this.localSelected = this.findLocal(this.requisicaoServico.idLocal);
      this.observacao = this.requisicaoServico.observacao;

      this.produtosL.forEach((e) => {
        this.$set(e, "index", index++);
        this.$set(e, "editingCentroCusto", false);
        this.$set(e, "centroCustoErro", false);
        this.$set(
          e,
          "centroCustoSelected",
          this.findCentroCusto(e.idCentroCusto)
        );
      });
    },
    async obterListas() {
      await this.atualizarServicos();
    },
    findUnidadeAdm(undAdmId) {
      return this.locais.find((uda) => uda.id === undAdmId);
    },
    findLocal(localId) {
      return this.locais.find((l) => l.id === localId);
    },
    findCentroCusto(centroCustoId) {
      return this.centrosCusto.find((c) => c.id === centroCustoId);
    },
    mountObjRequisicao(newreq) {
      var requisicaoServico = { ...newreq };
      requisicaoServico.id = this.requisicaoServico.id;
      requisicaoServico.observacao = this.observacao;
      requisicaoServico.status = this.requisicaoServico.status;
      requisicaoServico.prioridade = this.tipo;
      requisicaoServico.idUnidadeAdm = this.unidadeAdmSelected.id;
      requisicaoServico.idLocal = this.localSelected.id;
      requisicaoServico.unidadeAdm = this.unidadeAdmSelected.descricao;
      requisicaoServico.local = this.localSelected.descricao;
      requisicaoServico.ativo = true;
      requisicaoServico.data = new Date();
      //requisicao.produtos = this.produtosL;
      requisicaoServico.produtos = newreq.produtos;
      return requisicaoServico;
    },

    validarQuantidadeItem(quantidade) {
      return Number(quantidade) > 0 || "A quantidade deve ser maior que zero";
    },
    validarQuantidadeItens() {
      return this.produtosL.every(
        (item) => this.validarQuantidadeItem(item.quantidade) === true
      );
    },
    validarCentroCustoItens() {
      this.produtosL.forEach((i) => {
        if (i.centroCustoSelected && i.centroCustoSelected.id) {
          i.idCentroCusto = i.centroCustoSelected.id;
          i.centroCusto = i.centroCustoSelected.descricao;
        }

        i.centroCustoErro = !(i.centroCusto && i.idCentroCusto);
      });

      return this.produtosL.every((i) => i.centroCusto && i.idCentroCusto);
    },
  },
  created: function () {
    this.carregarTela();
  },
  components: {
    Servico,
    EditaProduto,
  },
};
</script>
<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
